import Masked from './Masked';
import { CustomerName } from './CustomerName';

interface NameParts {
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

interface AccountHolderNameProps {
  /** The account-holder person object, e.g. `complaint.userDatum`. */
  user?: NameParts | null;
  /**
   * A pre-built name string, for call sites that already have the
   * formatted account-holder name (e.g. the referral summary's
   * `accountHolderName` field).
   */
  value?: string | null;
  className?: string;
}

/**
 * Masked account-holder name (Medallia DXA PII masking, CD-8245).
 *
 * Distinct semantic component from {@link CustomerName} by design (the
 * account holder is a specific identity concept in the complaint domain),
 * but reuses the identical `title/firstName/lastName` formatting so
 * behaviour matches today's `<UserName>` usage in the AccountHolder section.
 */
export function AccountHolderName({ user, value, className }: AccountHolderNameProps) {
  if (value !== undefined) {
    return <Masked className={className}>{value}</Masked>;
  }

  return <CustomerName user={user} className={className} />;
}

export default AccountHolderName;
